import GuiContext from "config/context/guiContext";
import { useCallback, useContext, useState } from "react";
import { useCompositionsContext } from "../context/CompositionsContext";

const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useGetDatabaseScopesService= () => {
    const { setDatabaseScopes } = useCompositionsContext();
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    // Postojana, iz istog razloga kao `getDatabaseStructure`: drži je
    // `DatabaseScopesFetcher` u `useEffect`-u, pa bi nestabilna funkcija u
    // zavisnostima napravila petlju zahteva.
    const getDatabaseScopes = useCallback(async () => {
        setLoading(true);
        try {
            const res = await fetch(`${URL}/api/database/scopes`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    database: selectedAccount || "",
                    server_url: selectedServer || "",
                }),
            });

            const data = await res.json();
            setResponse(data);
            if (data?.status) {
                setDatabaseScopes(data.scopes || []);
            }
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    }, [URL, selectedAccount, selectedServer, setDatabaseScopes]);

    const resetServerStatus = useCallback(() => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }, []);

    return {
        response,
        loading,
        error,
        getDatabaseScopes,
        resetServerStatus
    }
}